import React, { FC } from 'react'
import { Helmet } from 'react-helmet'

export const FeedbotHelmet: FC = () => {
  const botId = getBotIdFromRawUrl()

  return (
    <Helmet>
      <title>{botId ? `${botId} | ` : ''}Feedyou Platform</title>
    </Helmet>
  )
}

// This is an exceptional approach - usually we would take bot id from React router, but we want to render helmet above router
// And we don't want to take the id from store, because we want to access it as soon as possible (and it takes quite a while to save it there)
const getBotIdFromRawUrl = () => {
  const path = window.location.pathname
  const botIdPattern = /\/bots\/([^/]+)/
  const match = path.match(botIdPattern)

  return match?.[1] || undefined
}
